import { cleanupStep1 } from './cleanupStep1';
import { cleanupStep2 } from './cleanupStep2';
import { cleanupStep3 } from './cleanupStep3';
import { cleanupStep4 } from './cleanupStep4';
import { cleanupStep5 } from './cleanupStep5';
import { cleanupStep6 } from './cleanupStep6';

export const cleanupFunctions = {
  1: cleanupStep1,
  2: cleanupStep2,
  3: cleanupStep3,
  4: cleanupStep4,
  5: cleanupStep5,
  6: cleanupStep6
};

// Главная функция очистки для всех шагов
export const cleanupAllSteps = (data) => {
  let cleanedData = { ...data };
  
  // Применяем очистку для всех шагов последовательно
  Object.values(cleanupFunctions).forEach(cleanupFn => {
    cleanedData = cleanupFn(cleanedData);
  });
  
  return cleanedData;
};

// Функция очистки для конкретного шага
export const cleanupStep = (step, data) => {
  const cleanupFn = cleanupFunctions[step];
  if (cleanupFn) {
    return cleanupFn(data);
  }
  return data;
};